import React, { useEffect, useMemo, useState } from 'react';
import { Button, Input, List, Modal, Row, Typography, message } from 'antd';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { postCall } from '../../../utils/network.util';
import { CREATE_COACH_TYPE_URL, GET_COACH_TYPE_URL } from '../../../utils/api-url';
import { checkToViewMetaDataPage } from '../../../components/app-header/app.header.module';
import { isValidArray } from '../../../utils/utilities';

const { Title, Text } = Typography;

export const CoachTypesPage = () => {
  const [loading, setLoading] = useState(false);
  const [coachTypes, setCoachTypes] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newName, setNewName] = useState('');

  const canCreate = useMemo(() => checkToViewMetaDataPage(), []);

  const fetchCoachTypes = async () => {
    setLoading(true);
    try {
      const res = await postCall(GET_COACH_TYPE_URL, {});
      if (res?.status === 'SUCCESS' && res?.payload?.Status === 'SUCCESS') {
        const list = res.payload.Payload;
        setCoachTypes(isValidArray(list) ? list : []);
      } else {
        setCoachTypes([]);
        message.error(res?.payload?.Message || 'Failed to fetch coach types');
      }
    } catch (e) {
      console.error(e);
      setCoachTypes([]);
      message.error('Failed to fetch coach types');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoachTypes();
  }, []);

  const onCreate = async () => {
    const name = String(newName || '').trim();
    if (!name) {
      message.error('Coach type name is required');
      return;
    }
    setLoading(true);
    try {
      const res = await postCall(CREATE_COACH_TYPE_URL, { name });
      if (res?.status === 'SUCCESS' && res?.payload?.Status === 'SUCCESS') {
        const list = res.payload.Payload;
        setCoachTypes(isValidArray(list) ? list : []);
        setIsModalOpen(false);
        setNewName('');
        message.success('Coach type created');
      } else {
        message.error(res?.payload?.Message || 'Failed to create coach type');
      }
    } catch (e) {
      console.error(e);
      message.error('Failed to create coach type');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
        <div>
          <Title level={3} style={{ marginBottom: 0 }}>Coach Types</Title>
          {/* <Text type="secondary">Admin → Metadata</Text> */}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <Button icon={<ReloadOutlined />} onClick={fetchCoachTypes} loading={loading}>
            Refresh
          </Button>
          {canCreate && (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>
              New
            </Button>
          )}
        </div>
      </Row>

      <List
        bordered
        loading={loading}
        dataSource={coachTypes}
        locale={{ emptyText: 'No coach types found' }}
        renderItem={(item) => (
          <List.Item>
            <Text>{item?.name}</Text>
          </List.Item>
        )}
        style={{background:'white'}}
      />

      <Modal
        title="Create coach type"
        visible={isModalOpen}
        okText="Create"
        onOk={onCreate}
        onCancel={() => {
          setIsModalOpen(false);
          setNewName('');
        }}
        confirmLoading={loading}
        okButtonProps={{ disabled: !String(newName || '').trim() }}
      >
        <Input
          autoFocus
          placeholder="Type name (e.g. Volvo A/C Sleeper)"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          onPressEnter={onCreate}
          maxLength={100}
        />
      </Modal>
    </div>
  );
};

